import React, { useState, useEffect } from 'react';

export const BestSellers = ({ bestSellers, products, featuredProduct }) => {
  // Generate tabs dynamically from bestSellers object
  const categoryTabs = Object.keys(products || {});

  // Default to first available tab
  const [activeTab, setActiveTab] = useState(categoryTabs[0] || 'Chairs');

  // Update active tab when backend categories change
  useEffect(() => {
    if (categoryTabs.length > 0) {
      setActiveTab(categoryTabs[0]);
    }
  }, [products]);

  console.log({ bestSellers, products, featuredProduct });

  return (
    <section
      className="bg-cover bg-center bg-no-repeat py-20 px-6 sm:px-12 lg:px-48 text-white"
      style={{ backgroundImage: `url(${bestSellers?.backgroundImage})` }}
    >
      {/* ===== Header Row ===== */}
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
        <div className="mb-6 md:mb-0">
          <h2 className="text-2xl sm:text-5xl font-semibold text-left text-[#F8AF10] just-me-again-down-here-regular">
            {bestSellers?.label}
          </h2>
          <p className="text-sm sm:text-base mt-2 text-left">{bestSellers?.caption}</p>
        </div>

        {/* Dynamic Tabs */}
        <div className="flex space-x-6 justify-start md:justify-end text-sm sm:text-base font-medium">
          {categoryTabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`transition ${activeTab === tab ? 'font-bold' : 'opacity-75'}`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* ===== Content Grid ===== */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        {/* Left side (featured product) */}
        <div className="flex flex-col items-start">
          <div className="w-full overflow-hidden">
            <img
              src={featuredProduct?.image}
              alt={featuredProduct?.title}
              className="w-full h-[400px] sm:h-[500px] object-cover shadow-lg"
            />
          </div>
          <p className="mt-4 text-sm sm:text-base font-medium">{featuredProduct?.title}</p>
        </div>

        {/* Right side products grid */}
        <div className="grid grid-cols-2 sm:grid-cols-2 gap-6">
          {products?.[activeTab]?.map((item, index) => (
            <div key={index} className="flex flex-col items-center text-center group">
              <div className="w-full overflow-hidden">
                <img
                  src={item.image} // FIX: product.image
                  alt={item.title} // FIX: product.title
                  className="w-full h-44 sm:h-56 object-cover transform transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <p className="mt-3 text-sm sm:text-base font-medium">
                {item.title} {/* FIX: product.title */}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
